/**
 * Счётчик непрочитанных в заголовке вкладки: «(3) alg(success)».
 *
 * Почему отдельный хук, а не строчка в App: логика «0 — без скобок,
 * N — (N)» нужна в одном месте, и App не должен помнить исходный title.
 * Базовый заголовок берём один раз из index.html при монтировании —
 * возвращаем его же, когда непрочитанных нет.
 *
 * ВАЖНО: хук ничего не знает о Matrix. Ему дают готовое число — так его
 * можно использовать и для будущего счётчика упоминаний, не переписывая.
 *
 * OVERRIDE (шаг 3, входящие звонки): пока идёт входящий звонок, маркер
 * «📞 Идёт звонок» ВАЖНЕЕ счётчика непрочитанных — человек обязан увидеть
 * звонок даже в свёрнутой вкладке. Без override два хука переписывали бы
 * title друг через друга: пришло сообщение во время звонка — маркер слетел.
 * useIncomingCall передаёт свой маркер сюда и НЕ трогает title сам, пока
 * override активен: единственный писатель в title — этот хук.
 */
import { useEffect, useRef } from "react";

export function useUnreadTitle(unread: number, override?: string | null): void {
  // Исходный title из index.html запоминаем ОДИН раз: иначе после первого
  // «(3) alg(success)» базовой строкой стало бы уже значение со скобками,
  // и счётчик начал бы накапливаться: «(5) (3) alg(success)».
  const baseTitle = useRef<string>(document.title);

  useEffect(() => {
    if (override) {
      document.title = override;
      return;
    }
    document.title = unread > 0 ? `(${unread}) ${baseTitle.current}` : baseTitle.current;
    // Восстанавливать при размонтировании нечего: приложение одно,
    // хук живёт столько же, сколько и оно.
  }, [unread, override]);
}
